// TYPES

import { ReducerAction } from 'store/modules/types';
import { AtualizarCidadaoAutistaRequest, Types } from './types';

export function atualizarCidadaoAutistaRequest(
	payload: AtualizarCidadaoAutistaRequest,
): ReducerAction {
	return {
		type: Types.ATUALIZAR_CIDADAO_AUTISTA_REQUEST,
		payload,
	};
}

export function atualizarCidadaoAutistaSuccess(payload: object): ReducerAction {
	return {
		type: Types.ATUALIZAR_CIDADAO_AUTISTA_SUCCESS,
		payload,
	};
}

export function atualizarCidadaoAutistaFailure(payload: object): ReducerAction {
	return {
		type: Types.ATUALIZAR_CIDADAO_AUTISTA_FAILURE,
		payload,
	};
}

export function atualizarCidadaoAutistaClear(): ReducerAction {
	return {
		type: Types.ATUALIZAR_CIDADAO_AUTISTA_CLEAR,
		payload: null,
	};
}
